/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UnitRateCrawlerConfigurationForAzureEA extends models.UnitRateCrawlerConfiguration {
    constructor() {
        super();
        this.setDiscriminator("UnitRateCrawlerConfigurationForAzureEA");
    }

    getFixupPrototypeFunction() { return UnitRateCrawlerConfigurationForAzureEA.fixupPrototype; }

    static newInstance(model: Partial<UnitRateCrawlerConfigurationForAzureEA>): UnitRateCrawlerConfigurationForAzureEA {
        let obj = Object.assign(new UnitRateCrawlerConfigurationForAzureEA(), model);
        UnitRateCrawlerConfigurationForAzureEA.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UnitRateCrawlerConfigurationForAzureEA>): UnitRateCrawlerConfigurationForAzureEA {
        if (!model) return null;
        return UnitRateCrawlerConfigurationForAzureEA.newInstance(<UnitRateCrawlerConfigurationForAzureEA> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UnitRateCrawlerConfigurationForAzureEA) {
        if (!obj) return;

        models.UnitRateCrawlerConfigurationForAzureEA.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UnitRateCrawlerConfigurationForAzureEA): boolean {
        if (models.UnitRateCrawlerConfiguration.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, UnitRateCrawlerConfigurationForAzureEA.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    parent_account_id: string;

    enrollment_id: string;

    subscription_id: string;

    account_id: string;

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency_code: models.Currency;

}
